import { render, staticRenderFns } from "./ViewClientSidebar.vue?vue&type=template&id=9aef660e&scoped=true&"
import script from "./ViewClientSidebar.vue?vue&type=script&lang=js&"
export * from "./ViewClientSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ViewClientSidebar.vue?vue&type=style&index=0&id=9aef660e&prod&lang=scss&scoped=true&"
import style1 from "./ViewClientSidebar.vue?vue&type=style&index=1&id=9aef660e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aef660e",
  null
  
)

export default component.exports